import React from "react";
import PropTypes from "prop-types";
import { Button, Card, CardTitle, Avatar, CardActions, FontIcon, TextField } from "react-md";

const styleDiv = { display: "contents" };
const styleCard = { maxWidth: 320, display: "inline-block", verticalAlign: "top" };
class SearchCard extends React.Component {
    constructor() {
        super();
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.click = this.click.bind(this);
    }
    
    handleKeyPress(event) {
        if(event.key == "Enter"){
            this.props.history.push({ pathname: this.props.pathname, state: { searchText: this._element.value } });
        }
    }

    click() {
        this.props.history.push({ pathname: this.props.pathname, state: { searchText: this._element.value } });
    }

    render() {
        return (
            <div className={this.props.className} style={styleDiv}>
                <Card style={styleCard} className="md-cell md-cell--6 md-cell--8-tablet" raise={true}>
                    <CardTitle
                        title={this.props.title}
                        subtitle={this.props.subTitle}
                        avatar={<Avatar icon={<FontIcon>{this.props.icon}</FontIcon>} />}
                    />
                    <CardActions style={{ maxHeight: 70 }}>
                        <TextField
                            id="floating-center-title"
                            label={this.props.actionName}
                            lineDirection="center"
                            placeholder={this.props.actionName}
                            className="md-cell md-cell--bottom"
                            ref={element => this._element = element}
                            style={{ width: "80%" }}
                            onKeyPress={this.handleKeyPress}
                        />
                        <Button style={{ top: 5 }} icon onClick={this.click}>
                            search
                        </Button>
                    </CardActions>
                </Card>
            </div>
        );
    }
}

SearchCard.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired,
    actionName: PropTypes.string.isRequired,
};

export default SearchCard;